import React from 'react';

import Card from 'components/DesignSystem/Card';
import DessemSerieChart from 'components/Relatorios/Dessem/DessemSerieChart';
import SecaoDessemEstado from 'components/Relatorios/Dessem/secoes/shared/SecaoDessemEstado';

import useDessemSecaoParams from 'hooks/Relatorios/Dessem/useDessemSecaoParams';
import { useGetDessemCargaLiquidaQuery } from 'services/api/products/relatorios';

export default function CargaLiquida() {
  const params = useDessemSecaoParams();

  const resultado = useGetDessemCargaLiquidaQuery(params);

  return (
    <SecaoDessemEstado resultado={resultado} params={params}>
      {(data) => (
        <Card title={data.titulo}>
          <DessemSerieChart
            periodos={data.periodos}
            series={data.series}
            destacarPico
            nomeEixoY="MW"
            eixoYAjustado
            option={data.option}
          />
        </Card>
      )}
    </SecaoDessemEstado>
  );
}
